import { GraphQLScalarType } from 'graphql';

export const GraphQLNullType = new GraphQLScalarType({
  name: 'Null',
});
